var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            "label-position": "top",
            model: _vm.form,
            rules: _vm.rules,
            "hide-required-asterisk": "",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Codigo", prop: "code" } },
            [
              _c("el-input", {
                attrs: {
                  size: "small",
                  disabled: _vm.loading || _vm.isEditor,
                  max: 10,
                },
                on: { input: _vm.onInput },
                model: {
                  value: _vm.form.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "code", $$v)
                  },
                  expression: "form.code",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Nombre", prop: "name" } },
            [
              _c("el-input", {
                attrs: { size: "small", disabled: _vm.loading },
                on: { input: _vm.onInput },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Correo electrónico", prop: "email" } },
            [
              _c("el-input", {
                attrs: { size: "small", disabled: _vm.loading },
                on: { input: _vm.onInput },
                model: {
                  value: _vm.form.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Descripcion", prop: "description" } },
            [
              _c("el-input", {
                attrs: { size: "small", disabled: _vm.loading },
                on: { input: _vm.onInput },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "", prop: "enabled" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { size: "small", disabled: _vm.loading },
                  on: { change: _vm.onInput },
                  model: {
                    value: _vm.form.active,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "active", $$v)
                    },
                    expression: "form.active",
                  },
                },
                [_vm._v("Activo")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          loading: _vm.loading,
                          type: "primary",
                          size: "medium",
                          disabled: _vm.disableSubmitButton,
                        },
                        on: { click: _vm.onSubmit },
                      },
                      [_vm._v(_vm._s(_vm.submitButtonText))]
                    ),
                  ],
                  1
                ),
              ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }